import { TransportOrderIdView } from '../../../../models';

export class ShipmentTransportOrderStatusChainLoad {
  public static readonly type = '[ShipmentTransportOrderStatusChain] Load Status Chain';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderStatusChainSetInitialState {
  public static readonly type = '[ShipmentTransportOrderStatusChain] Set Initial State';
}
